import { fetchAll } from './fetch';
import Family from 'models/family';

export default fetchAll('families', Family, [], { group: true });
